import Grid from '@mui/material/Grid';
import classNames from 'classnames';
import ReactMarkdown from 'react-markdown';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import useIsMobile from '/@/utils/hooks/is-mobile';
import Title from '/@/v3/components/title';
import styles from '../styles.module.css';

const IconTitleText = ({ icon, title, text, card = false, date, children, border = false }) => {
    const isMobile = useIsMobile();
    const isDetail = icon === 'statistics' && !isMobile && card;
    return (
        <Grid
            container
            direction='row'
            alignItems='center'
            justifyContent='center'
            sx={{
                height: '100%',
                marginLeft: 0,
                boxShadow: { xs: border && 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;', md: border && 'none' },
                p: { xs: border && 2, md: 0 },
                gap: 2,
            }}
            xs={12}
        >
            <Grid item xs={!card ? 2 : isMobile ? 12 : 2}>
                <Grid container justifyContent='center' alignItems='center'>
                    <Grid
                        item
                        sx={{
                            backgroundColor: (t) => t.palette.primary[400],
                            boxShadow: ' -3px 15px 20px rgba(0, 0, 0, 0.1)',
                            borderRadius: 3,
                        }}
                    >
                        <div className={classNames(styles.divIcon, card && isMobile && styles.smallerIcon)}>{icon}</div>
                    </Grid>
                </Grid>
            </Grid>
            <Grid
                item={!isMobile}
                xs={!card ? 9 : isMobile ? 12 : children ? 4 : 9}
                sx={{ alignItems: 'center', display: 'flex', pl: isDetail ? 4 : 0 }}
            >
                <Grid
                    container
                    justifyContent='flex-start'
                    alignItems='flex-start'
                    sx={isMobile && card && { textAlign: 'center' }}
                >
                    <Grid item xs={12}>
                        <Title
                            theme={settings.app.theme}
                            bolder={card}
                            size={card && isMobile && 'sm'}
                            className={!card && styles.title}
                        >
                            {_(title)}
                        </Title>
                    </Grid>
                    {text && (
                        <Grid item xs={12}>
                            <Title className={styles.text}>
                                {
                                    <ReactMarkdown className={classNames(styles.text, card && styles.statisticsText)}>
                                        {_(text)}
                                    </ReactMarkdown>
                                }
                            </Title>
                        </Grid>
                    )}
                    {date && (
                        <Grid item xs={12}>
                            <Grid
                                container
                                justifyContent={isMobile && card && 'center'}
                                spacing={1}
                                wrap='nowrap'
                                alignItems='center'
                            >
                                <Grid item>
                                    <Title size='sm' bolder theme={settings.app.theme}>
                                        <i style={{ fontSize: '14px' }} className='material-icons'>
                                            today
                                        </i>
                                    </Title>
                                </Grid>
                                <Grid item>
                                    <Title size='sm' bolder theme={settings.app.theme}>
                                        {date}
                                    </Title>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            {children && (
                <Grid item xs={4} sx={{ pt: 2 }}>
                    {children}
                </Grid>
            )}
        </Grid>
    );
};

export default IconTitleText;
